import UsersState from "@/store/modules/users/usersState";
import { Getters } from "vuex-smart-module";
import UserModel from "@/models/UserModel";

export default class UsersGetters extends Getters<UsersState> {
  get users(): UserModel[] | undefined {
    return this.state.users;
  }
}
